import "../Main.css";
import { Button, Flex, Image, Input, Text, Textarea } from "@chakra-ui/react";
import axios from "axios";
import { AdminMenuBar } from "../../components/admin/AdminMenuBar";
import Address from "../../components/Address";
import { useEffect, useState, useRef } from "react";
import PreviewImage from "../../images/img.png";
import DetailCard from "../../components/admin/product/DetailCard";
import Modal from "react-modal";
import { checkSession } from "../../services/Admin";

const AdminProductDetail = () => {
    const [productDetailData, setProductDetailData] = useState([]);
    const [productDetailCards, setProductDetailCards] = useState([]);
    const [titleImage, setTitleImage] = useState();
    const [titleText, setTitleText] = useState();
    const [productName, setProductName] = useState();
    const [currentPageId, setCurrentPageId] = useState();
    const [sortType, setSortType] = useState();
    const [isEditMode, setIsEditMode] = useState(false);

    const [isModalOpen, setIsModalOpen] = useState(false);

    const scrollToTop = () => {
        window.scrollTo({
            top: 0,
            behavior: "smooth", // 부드럽게 스크롤링되도록 설정 (선택적)
        });
    };

    const [value, setValue] = useState(""); // 인증서명
    const [content, setContent] = useState("");
    const handleChange = (event) => setValue(event.target.value);
    const handleChangeContent = (event) => setContent(event.target.value);

    const [file, setFile] = useState(null); // 파일 임시 저장 변수
    const [pdfFile, setPdfFile] = useState(null); // 파일 임시 저장 변수
    const [imgBase64, setImgBase64] = useState(null); // 파일 base64
    const [pdf, setPdf] = useState(null);
    const [pdfFileName, setPdfFileName] = useState(null);
    const [imgName, setImgName] = useState(null);
    const [editId, setEditId] = useState(null);

    const clearState = () => {
        setContent(null);
        setValue(null);
        setFile(null);
        setImgBase64(null);
        setImgName(null);
        setPdf(null);
        setPdfFile(null);
        setPdfFileName(null);
        setIsEditMode(false);
        setIsModalOpen(false);
    };

    const fileChange = (event) => {
        setFile(event.target.files[0]);

        setImgBase64([]);

        for (var i = 0; i < event.target.files.length; i++) {
            if (event.target.files[i]) {
                let reader = new FileReader();
                reader.readAsDataURL(event.target.files[i]); // 1. 파일을 읽어 버퍼에 저장.
                // 파일 상태 업데이트
                reader.onloadend = () => {
                    // 2. 읽기가 완료되면 아래코드가 실행.
                    const base64 = reader.result;
                    if (base64) {
                        // 문자 형태로 저장
                        var base64Sub = base64.toString();
                        // 배열 state 업데이트
                        setImgBase64((imgBase64) => [...imgBase64, base64Sub]);
                    }
                };
            }
        }
    };

    const pdfFileChange = (e) => {
        setPdfFile(e.target.files[0]);
        const file = e.target.files[0];
        const fileUrl = URL.createObjectURL(file);
        setPdf(fileUrl);
    };

    const inputRef = useRef(null);
    const inputRefForPdf = useRef(null);

    const handleClick = () => {
        // 👇️ open file input box on click of other element
        inputRef.current.click();
    };

    const pdfHandleClick = () => {
        // 👇️ open file input box on click of other element
        inputRefForPdf.current.click();
    };

    useEffect(() => {
        pdfFile && setPdfFileName(pdfFile.name);
    }, [pdfFile]);

    useEffect(() => {
        file && setImgName(file.name);
    }, [file]);

    const postFileClick = () => {
        postFile();
    };

    const editFile = () => {
        var fileData = new FormData();
        file && fileData.append("file", file);
        if (sortType === "2") {
            pdfFile && fileData.append("catalog", pdfFile);
        }

        if (sortType === "1" || sortType === "3") {
            axios
                .put(`/api/productDetail/${editId}?name=${value}&content=${content}`, fileData, {
                    headers: {
                        "Content-Type": "multipart/form-data",
                    },
                })
                .then((res) => {
                    currentPageId &&
                        axios
                            .get("/api/productDetail", {
                                params: {
                                    id: currentPageId,
                                },
                            })
                            .then((res) => {
                                setProductName(res.data.productDTO["name"]);
                                setProductDetailData(res.data.detailDtoList);
                            });
                })
                .catch((ex) => {
                    if (ex.response.status === 401) {
                        window.location.href = `/admin/login`;
                        alert("접근권한이 없습니다.");
                    } else {
                        window.location.href = `/admin/login`;
                        alert("서버에 이상이 있습니다. 관리자에게 문의주세요");
                    }
                });
        } else {
            axios
                .put(`/api/productDetail/catalog/${editId}?name=${value}`, fileData, {
                    headers: {
                        "Content-Type": "multipart/form-data",
                    },
                })
                .then((res) => {
                    currentPageId &&
                        axios
                            .get("/api/productDetail", {
                                params: {
                                    id: currentPageId,
                                },
                            })
                            .then((res) => {
                                setProductName(res.data.productDTO["name"]);
                                setProductDetailData(res.data.detailDtoList);
                            });
                })
                .catch((ex) => {
                    if (ex.response.status === 401) {
                        window.location.href = `/admin/login`;
                        alert("접근권한이 없습니다.");
                    } else {
                        window.location.href = `/admin/login`;
                        alert("서버에 이상이 있습니다. 관리자에게 문의주세요");
                    }
                });
        }
        alert("세부사항 편집되었습니다!");
        setIsModalOpen(false);
    };

    const postFile = () => {
        var fileData = new FormData();
        fileData.append("file", file);
        if (sortType === "2") {
            fileData.append("catalog", pdfFile);
        }
        if (sortType === "1" || sortType === "3") {
            axios
                .post(`/api/productDetail?name=${value}&content=${content}&productID=${currentPageId}`, fileData, {
                    headers: {
                        "Content-Type": "multipart/form-data",
                    },
                })
                .then((res) => {
                    currentPageId &&
                        axios
                            .get("/api/productDetail", {
                                params: {
                                    id: currentPageId,
                                },
                            })
                            .then((res) => {
                                setProductName(res.data.productDTO["name"]);
                                setProductDetailData(res.data.detailDtoList);
                            });
                })
                .catch((ex) => {
                    if (ex.response.status === 401) {
                        window.location.href = `/admin/login`;
                        alert("접근권한이 없습니다.");
                    } else {
                        window.location.href = `/admin/login`;
                        alert("서버에 이상이 있습니다. 관리자에게 문의주세요");
                    }
                });
        } else {
            axios
                .post(`/api/productDetail/catalog?name=${value}&productID=${currentPageId}`, fileData, {
                    headers: {
                        "Content-Type": "multipart/form-data",
                    },
                })
                .then((res) => {
                    currentPageId &&
                        axios
                            .get("/api/productDetail", {
                                params: {
                                    id: currentPageId,
                                },
                            })
                            .then((res) => {
                                setProductName(res.data.productDTO["name"]);
                                setProductDetailData(res.data.detailDtoList);
                            });
                })
                .catch((ex) => {
                    if (ex.response.status === 401) {
                        window.location.href = `/admin/login`;
                        alert("접근권한이 없습니다.");
                    } else {
                        window.location.href = `/admin/login`;
                        alert("서버에 이상이 있습니다. 관리자에게 문의주세요");
                    }
                });
        }

        alert("세부사항 추가되었습니다!");
        setIsModalOpen(false);
    };

    const confirmForm = () => {
        if (sortType === "1" || sortType === "3") {
            if ((value === "" || value === null) && (content === "" || content === null) && imgBase64 === null) {
                alert("이름, 상세내용 및 사진 업로드를 완료해주세요!");
            } else if (value === "" || value === null) {
                alert("이름을 입력해주세요!");
            } else if (content === "" || content === null) {
                alert("상세내용을 입력해주세요!");
            } else if (imgBase64 === null) {
                alert("사진을 업로드 해주세요!");
            } else {
                if (isEditMode) {
                    editFile();
                } else {
                    postFileClick();
                }
                setIsModalOpen(false);
                setValue("");
                setImgBase64("");
                setFile("");
                setContent("");
            }
        } else {
            if ((value === "" || value === null) && pdf === null && imgBase64 === null) {
                alert("이름, 사진, pdf파일 업로드를 완료해주세요!");
            } else if (value === "" || value === null) {
                alert("이름을 입력해주세요!");
            } else if (imgBase64 === null) {
                alert("사진을 업로드 해주세요!");
            } else if (pdf === null && !isEditMode) {
                alert("pdf파일을 업로드 해주세요!");
            } else {
                if (isEditMode) {
                    editFile();
                } else {
                    postFileClick();
                }
                setIsModalOpen(false);
                setValue("");
                setImgBase64("");
                setFile("");
                setContent("");
            }
        }
    };

    const deleteCard = (id, name) => {
        if (window.confirm(name + " 정보를 정말로 삭제하시겠습니까??")) {
            axios
                .delete(`/api/productDetail/${id}`)
                .then((res) => {
                    if (res.status === 200) {
                        alert("삭제가 완료되었습니다!");
                        axios
                            .get("/api/productDetail", {
                                params: {
                                    id: currentPageId,
                                },
                            })
                            .then((res) => {
                                setProductDetailData(res.data.detailDtoList);
                            });
                    }
                })
                .then()
                .catch((ex) => {
                    if (ex.response.status === 401) {
                        window.location.href = `/admin/login`;
                        alert("접근권한이 없습니다.");
                    } else {
                        window.location.href = `/admin/login`;
                        alert("서버에 이상이 있습니다. 관리자에게 문의주세요");
                    }
                });
        }
    };

    useEffect(() => {
        checkSession();
        scrollToTop();
        setCurrentPageId(window.location.href.split("id=")[1]);
        axios.get("/api/product/title").then((res) => {
            setTitleImage(res.data.imageUrl);
            setTitleText(res.data.name);
        });
    }, []);

    useEffect(() => {
        currentPageId &&
            axios
                .get("/api/productDetail", {
                    params: {
                        id: currentPageId,
                    },
                })
                .then((res) => {
                    setProductName(res.data.productDTO["name"]);
                    setSortType(res.data.productDTO["sortType"]);
                    setProductDetailData(res.data.detailDtoList);
                });
    }, [currentPageId]);

    useEffect(() => {
        let cards = [];
        productDetailData.map((productDetail) => {
            cards.push(
                <DetailCard
                    key={productDetail["id"]}
                    id={productDetail["id"]}
                    cardType={sortType}
                    productType={productDetail["type"]}
                    name={productDetail["name"]}
                    image={productDetail["imageUrl"]}
                    content={productDetail["content"]}
                    onClickDeleteButton={() => {
                        deleteCard(productDetail["id"], productDetail["name"]);
                    }}
                    setIsModalOpen={setIsModalOpen}
                    setValue={setValue}
                    setContent={setContent}
                    imgBase64={imgBase64}
                    setImgBase64={setImgBase64}
                    setPdfFileName={setPdfFileName}
                    setImgName={setImgName}
                    setIsEditMode={setIsEditMode}
                    setEditId={setEditId}
                    setPdf={setPdf}
                />
            );
        });
        setProductDetailCards(cards);
    }, [productDetailData]);

    return (
        <div>
            <AdminMenuBar selected_page={3} />
            <div
                className="w-full h-[300px] bg-black text-8xl font-bold text-white flex items-center justify-center bg-[length:100%_100%]"
                style={{ backgroundImage: `url(${titleImage})` }}
            >
                {titleText}
            </div>

            <div style={{ marginLeft: "10%", marginTop: "1%", fontSize: "xx-large", fontWeight: "bold" }}>
                {productName}
            </div>
            <Flex maxW="100%" justifyContent="left" marginLeft="10%" marginTop="3%" marginBottom="1%">
                <div className="flex items-end">
                    <Button
                        colorScheme="blue"
                        fontSize="3xl"
                        px="10px"
                        py="20px"
                        onClick={() => {
                            clearState();
                            setIsModalOpen(true);
                        }}
                    >
                        내용추가
                    </Button>
                    <div className="flex items-end ml-[10px]">
                        <div>
                            <div className="text-2xl">버튼을 클릭해 제품의 세부내용을 추가할 수 있습니다</div>
                            <div className="text-2xl">
                                정보를 [삭제]하거나 [편집]하려면 각 정보카드 하단에 있는 버튼을 클릭해 주세요
                            </div>
                        </div>
                    </div>
                </div>
            </Flex>
            <div style={{ width: "90vw", marginLeft: "10vw" }}>
                <div style={{ display: "flex", flexWrap: "wrap", justifyContent: "flexStart" }}>
                    {productDetailCards}
                </div>
            </div>

            <Modal
                ariaHideApp={false}
                isOpen={isModalOpen}
                style={{
                    content: {
                        width: "1000px",
                        height: "550px",
                        margin: "auto",
                        marginTop: "80px",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                    },
                }}
            >
                <Flex alignItems="center" direction="column">
                    <Flex alignContent="center" mb="10px" mt="10px">
                        <Button
                            ml="5px"
                            width="80px"
                            fontSize="xl"
                            height="25px"
                            size="md"
                            colorScheme={sortType === "1" ? "red" : "gray"}
                            isDisabled={sortType === "1" ? false : true}
                        >
                            Type1
                        </Button>
                        <Button
                            ml="5px"
                            width="80px"
                            fontSize="xl"
                            height="25px"
                            size="md"
                            colorScheme={sortType === "2" ? "red" : "gray"}
                            isDisabled={sortType === "2" ? false : true}
                        >
                            Type2
                        </Button>
                        <Button
                            ml="5px"
                            width="80px"
                            fontSize="xl"
                            height="25px"
                            size="md"
                            colorScheme={sortType === "3" ? "red" : "gray"}
                            isDisabled={sortType === "3" ? false : true}
                        >
                            Type3
                        </Button>
                    </Flex>
                    <Text fontSize="5xl" as="b" mb="30px" mt="10px">
                        {isEditMode ? "내용 및 특징 편집" : "내용 및 특징 추가"}
                    </Text>

                    <Flex alignContent="center" mb="10px" mt="10px">
                        <div style={{ height: "300px", marginRight: "50px", overflowY: "auto" }}>
                            <Flex alignContent="center" mb="10px" mt="10px">
                                <Text fontSize="2xl" fontWeight={800} mt="-3px" width="300px">
                                    &nbsp;{value}
                                </Text>
                            </Flex>

                            {sortType === "1" ? (
                                <>
                                    <Image
                                        mt="10px"
                                        mb="10px"
                                        height="200px"
                                        width="300px"
                                        src={imgBase64 ? imgBase64 : PreviewImage}
                                        alt="미리보기"
                                    />
                                    <Flex alignContent="center" mb="10px" mt="10px">
                                        <Text fontSize="2xl" fontWeight={800} mt="-3px" width="300px">
                                            &nbsp;{content}
                                        </Text>
                                    </Flex>
                                </>
                            ) : sortType === "2" ? (
                                <div className="flex justify-center relative">
                                    <Image
                                        mt="10px"
                                        mb="10px"
                                        height="200px"
                                        src={imgBase64 ? imgBase64 : PreviewImage}
                                        alt="미리보기"
                                    />

                                    <div className="absolute bottom-0 left-0 w-full">
                                        <div className="flex justify-center">
                                            <div
                                                className="w-1/2 catalogue_button font-bold"
                                                onClick={() => {
                                                    if (pdf) {
                                                        window.open(pdf);
                                                    } else {
                                                        alert("pdf 파일을 업로드해주세요");
                                                    }
                                                }}
                                            >
                                                온라인카다로그
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            ) : (
                                <Flex alignContent="center" mb="10px" mt="10px">
                                    <Image
                                        mt="10px"
                                        mb="10px"
                                        width="300px"
                                        height="200px"
                                        src={imgBase64 ? imgBase64 : PreviewImage}
                                        alt="미리보기"
                                    />
                                    <Flex
                                        alignContent="center"
                                        width="300px"
                                        mb="10px"
                                        mt="10px"
                                        style={{ border: "solid 1px gainsboro", borderRadius: "5px" }}
                                    >
                                        <Text fontSize="2xl" fontWeight={800} width="100%">
                                            &nbsp;{content}
                                        </Text>
                                    </Flex>
                                </Flex>
                            )}
                        </div>
                        <div>
                            <Flex alignContent="center" mb="10px" mt="10px">
                                <Text fontSize="2xl" mt="-3px" width="100px">
                                    이 름
                                </Text>
                                <Input
                                    htmlSize={15}
                                    value={value}
                                    placeholder="이름을 입력해주세요"
                                    onChange={handleChange}
                                    size="sm"
                                />
                            </Flex>
                            {sortType === "1" || sortType === "3" ? (
                                <>
                                    <Text fontSize="2xl" mt="-3px" width="100px">
                                        상 세 내 용
                                    </Text>
                                    <Textarea
                                        htmlSize={15}
                                        textAlign="top"
                                        h="200px"
                                        value={content}
                                        placeholder="상세내용을 입력해주세요"
                                        _placeholder={{ opacity: 0.4, color: "inherit" }}
                                        onChange={handleChangeContent}
                                        size="sm"
                                    />
                                </>
                            ) : (
                                <></>
                            )}

                            <Flex mb="8px" mt="2px">
                                <Input width="150px" value={imgName} readOnly />
                                <Button
                                    ml="5px"
                                    width="80px"
                                    fontSize="xl"
                                    height="25px"
                                    size="md"
                                    colorScheme="red"
                                    onClick={handleClick}
                                >
                                    이미지 선택
                                </Button>
                                <input
                                    style={{ display: "none" }}
                                    ref={inputRef}
                                    type="file"
                                    accept="image/*"
                                    onChange={fileChange}
                                />
                            </Flex>
                            {sortType === "2" ? (
                                <Flex mb="8px" mt="2px">
                                    <Input width="150px" value={pdfFileName} readOnly />
                                    <Button
                                        ml="5px"
                                        width="80px"
                                        fontSize="xl"
                                        height="25px"
                                        size="md"
                                        colorScheme="red"
                                        onClick={pdfHandleClick}
                                    >
                                        PDF 선택
                                    </Button>
                                    <input
                                        style={{ display: "none" }}
                                        ref={inputRefForPdf}
                                        type="file"
                                        accept=".pdf"
                                        onChange={pdfFileChange}
                                    />
                                </Flex>
                            ) : (
                                <></>
                            )}
                        </div>
                    </Flex>

                    <Flex mt="30px" mb="10px">
                        <Button fontSize="xl" size="md" colorScheme="red" mr={3} onClick={() => clearState()}>
                            닫기
                        </Button>
                        <Button fontSize="xl" size="md" colorScheme="gray" onClick={confirmForm}>
                            {isEditMode ? "편집" : "추가"}
                        </Button>
                    </Flex>
                </Flex>
            </Modal>

            <Address />
        </div>
    );
};

export default AdminProductDetail;
